export const DETAILS_MAP_ENABLED = {
  ORIGINAL: 'The original uploaded video file',
  HD: 'Perfect for most presentations or web uses',
  SD: 'Suited for slower connections or previews'
};